import React from "react";
import { InputLabel, TextInput, Title } from "@mantine/core";

interface TextInputFieldsProps {
  isNumber: boolean;
  text: any;
  updateText: (value: string | object) => void;
  updateTranslation: (lang: string, value: string) => void;
  t: (key: string) => string;
}

const TextInputFields: React.FC<TextInputFieldsProps> = ({
  isNumber,
  text,
  updateText,
  updateTranslation,
  t,
}: TextInputFieldsProps) => {
  if (isNumber) {
    return (
      <>
        <InputLabel>
          {t("scheme.redactor.panelOptions.setText.writeNumber")}
        </InputLabel>
        <TextInput
          value={typeof text === "string" ? text : ""}
          onChange={(e) => updateText(e.target.value)}
          placeholder={t("scheme.redactor.panelOptions.setText.writeNumber")}
        />
      </>
    );
  } else {
    return (
      <>
        <Title mt={10} order={4}>
          {t("scheme.redactor.panelOptions.setText.translations.title")}
        </Title>
        {["en", "ro", "ru"].map((lang) => (
          <React.Fragment key={lang}>
            <InputLabel mt={10}>
              {t(
                `scheme.redactor.panelOptions.setText.translations.${lang}.title`
              )}
            </InputLabel>
            <TextInput
              value={text[lang] || ""}
              onChange={(e) => updateTranslation(lang, e.target.value)}
              placeholder={t(
                `scheme.redactor.panelOptions.setText.translations.${lang}.placeholder`
              )}
            />
          </React.Fragment>
        ))}
      </>
    );
  }
};

export default React.memo(TextInputFields);
